import $root from '../static/proto-bundle'

const DataMessage = $root.lookup('DataMessage')

export const convertSessionDescriptionTypeIntToString = type => {
  switch (type) {
    case DataMessage.SessionDescription.Type.OFFER:
      return 'offer'
    case DataMessage.SessionDescription.Type.PRANSWER:
      return 'pranswer'
    case DataMessage.SessionDescription.Type.ANSWER:
      return 'answer'
    default:
      return 'offer'
  }
}

export const convertSessionDescriptionTypeStringToInt = type => {
  switch (type) {
    case 'offer':
      return DataMessage.SessionDescription.Type.OFFER
    case 'pranswer':
      return DataMessage.SessionDescription.Type.PRANSWER
    case 'answer':
      return DataMessage.SessionDescription.Type.ANSWER
    default:
      return DataMessage.SessionDescription.Type.OFFER
  }
}
